"use client";

import { useEffect, useState } from "react";

import { cn } from "@/lib/utils";
import type { DocTocEntry } from "./nav";

export function DocsToc({ toc }: { toc: DocTocEntry[] }) {
  const [activeId, setActiveId] = useState<string | null>(null);

  useEffect(() => {
    if (toc.length === 0) return;
    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries.filter((entry) => entry.isIntersecting);
        if (visible.length > 0) setActiveId(visible[0].target.id);
      },
      { rootMargin: "-80px 0px -70% 0px" },
    );
    for (const entry of toc) {
      const el = document.getElementById(entry.id);
      if (el) observer.observe(el);
    }
    return () => observer.disconnect();
  }, [toc]);

  if (toc.length === 0) return null;

  return (
    <div>
      <div className="mb-2 text-xs font-medium uppercase tracking-wide text-muted-foreground">
        On this page
      </div>
      <ul className="space-y-1 border-l border-border/60 text-[13px]">
        {toc.map((entry) => (
          <li key={entry.id}>
            <a
              href={`#${entry.id}`}
              className={cn(
                "-ml-px block border-l py-1 leading-5 transition-colors",
                entry.depth === 3 ? "pl-6" : "pl-3",
                activeId === entry.id
                  ? "border-lime-400 text-foreground"
                  : "border-transparent text-muted-foreground hover:text-foreground",
              )}
            >
              {entry.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}
